import { render, staticRenderFns } from "./CustomersOverview.vue?vue&type=template&id=559188f7&scoped=true&"
import script from "./CustomersOverview.vue?vue&type=script&lang=ts&"
export * from "./CustomersOverview.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./CustomersOverview.vue?vue&type=style&index=1&id=559188f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559188f7",
  null
  
)

export default component.exports